import { type Dialog } from '@chakra-ui/react'
import type { FC } from 'react'

import MetricIntegrationModal from './metricIntegrationModal'

import useStoreCurrentUser from '@app/hooks/useStoreCurrentUser'
import type { Credential } from '@graphql/types'

type Props = Partial<Dialog.RootProps> & {
  credential: Credential
  open: boolean
  onOpenChange: (e: { open: boolean }) => void
}

const MetricIntegrationEditModal: FC<Props> = ({ credential, open, onOpenChange, ...rest }) => {
  const { user } = useStoreCurrentUser()

  if (!user) {
    return null
  }

  return <MetricIntegrationModal credential={credential} open={open} onOpenChange={onOpenChange} {...rest} />
}

export default MetricIntegrationEditModal
